import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Rule from '../../components/rule'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'

const RulePage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Rules'} pagesub={'Rules'}/> 
            <Rule/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default RulePage;